import React from "react";
import "./componentStyles/EmployeeDetailCard.css";

const Row = ({ label, value }) => (
  <div className="detail-row">
    <div className="detail-label">{label}</div>
    <div className="detail-value">{value || "-"}</div>
  </div>
);

function fmtDate(d) {
  try {
    return d ? new Date(d).toLocaleDateString("tr-TR") : "-";
  } catch {
    return "-";
  }
}

export default function EmployeeDetailCard({ detail, loading, onClose, onTerminate, terminating }) {
  return (
    <div className="student-info-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h3>Öğrenci Detayı</h3>
        <button className="modal-close-btn" onClick={onClose}>×</button>
      </div>

      <div className="modal-body">
        {loading ? (
          <div className="loading-text">Yükleniyor...</div>
        ) : !detail ? (
          <div className="loading-text">Kayıt bulunamadı.</div>
        ) : (
          <>
            <Row label="Ad - Soyad" value={detail.studentName} />
            <Row label="Öğrenci No" value={detail.studentSicilNo} />
            <Row label="T.C. Kimlik No" value={detail.studentTcNo} />
            <Row label="Ziraat Bankası IBAN" value={detail.ibanText} />
            <Row label="Birim" value={detail.unitName} />
            <Row label="Çalıştığı Yer" value={detail.workplaceName} />
            <Row label="Yaptığı İş" value={detail.positionName} />
            <Row label="Sigorta Başlama Tarihi" value={fmtDate(detail.insuranceStartDate)} />
            <Row label="Bu Hafta Çalışılan Saat" value={`${detail.weekHours ?? 0} saat`} />
            <Row label="Bu Ay Toplam Çalışılan Saat" value={`${detail.monthHours ?? 0} saat`} />
          </>
        )}
      </div>

      <div className="modal-footer">
        <button className="cancel-btn" onClick={onClose}>Kapat</button>
        <button
          className="confirm-btn"
          onClick={onTerminate}
          disabled={terminating || loading}
        >
          {terminating ? "İşleniyor..." : "Sigorta Çıkışını Ver"}
        </button>
      </div>
    </div>
  );
}
